import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DeviceVinConfigComponent } from './device-vin-config.component';

const routes: Routes = [
  {
    path: 'device-vin-config',
    data: { name: 'Device Vin Config', isTab: false },
    component: DeviceVinConfigComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DeviceVinConfigPageRoutingModule {}
